// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__26SRU","showResults":"style_showResults__heKPj"};